import './Principal.css';

import MainInicio from "../MainInicio/MainInicio";
import ServiceInicio from "../ServiceInicio/ServiceInicio.js";
import SolucionesEducativas from "../Valores/Valores.js";
import Preload from "../Preload/Preload.js"
import Propositos from '../Proposito/Proposito.js';


function Principal (){
    return(
        <div className="principal">
            <div className="principal-contenedor">
                <MainInicio />

                <ServiceInicio/>

                {/* <Propositos/> */}

                <SolucionesEducativas/>


            </div>
        </div>


    );
}
export default Principal;